export default async (session, updateSession, syncSession) => {
  const newSession = { ...session };

  delete newSession.selectedOfferFamily;
  delete newSession.selectedOfferId;

  updateSession(newSession);
  await syncSession();
};
